import * as yup from 'yup';

const schema = yup.object().shape({
  comment: yup.string('Message must be string'),
});

export default schema;
